<div class="choose-area space" data-bg-src="assets/img/bg/category_bg_1.png">
    <div class="container">
        <div class="row gy-4 align-items-center flex-row-reverse">
            <div class="col-lg-6 order-1 order-lg-0">
                <div class="ps-xl-5">
                    <div class="title-area">
                        <span class="sub-title style1 text-anime-style-2">Why Choose Us</span>
                        <h2 class="sec-title  text-anime-style-3">IT Solutions Designed to Drive Results</h2>
                        <p class="wow fadeInUp">At Xipetech, we offer a complete range of services including IT
                            solutions and management, website and app development, as well as SEO and digital marketing.
                            Our expert team delivers reliable, scalable, and result-driven solutions tailored to your
                            business goals. We combine innovation with technology to help you grow smarter and faster in
                            today’s digital world.</p>
                    </div>
                    <div class="skill-feature">
                        <h3 class="skill-feature_title">IT Solution & Management</h3>
                        <div class="progress">
                            <div class="progress-bar" style="width: 95%;"></div>
                            <div class="progress-value">95%</div>
                        </div>
                    </div>
                    <div class="skill-feature">
                        <h3 class="skill-feature_title">Website & App Development</h3>
                        <div class="progress">
                            <div class="progress-bar" style="width: 90%;"></div>
                            <div class="progress-value">90%</div>
                        </div>
                    </div>
                    <div class="skill-feature">
                        <h3 class="skill-feature_title">SEO & Digital Marketing</h3>
                        <div class="progress">
                            <div class="progress-bar" style="width: 62%;"></div>
                            <div class="progress-value">62%</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 order-0 order-lg-1 d-none d-sm-block">
                <div class="choose-imgbox text-center text-md-start">
                    <div class="row align-items-center">
                        <div class="col-sm-7 col-md-7 col-xl-7">
                            <div class="img1">
                                <img class="w-100" src="assets/img/normal/about_10_1.jpg"
                                    alt="IT Solution & Management" />
                            </div>
                        </div>
                        <div class="col-sm-5 col-md-5 col-xl-5 d-lg-none d-xl-block">
                            <div class="img-box-sm">
                                <div class="img2 mb-25">
                                    <img class="th-radius" src="assets/img/normal/about_10_2.jpg"
                                        alt="Website & App Development" />
                                </div>
                                <div class="img3">
                                    <img class="th-radius" src="assets/img/normal/about_10_3.jpg"
                                        alt="SEO & Digital Marketing" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>